import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Check, X, MapPin, Mail, Clock } from "lucide-react";
import { get, patch } from "@/lib/api";
import { CATEGORY_LABELS } from "@/lib/data";

const APP_STATUS = {
  pending: { label: "Bekliyor", color: "bg-amber-100 text-amber-700 border-amber-200" },
  approved: { label: "Onaylandı", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  rejected: { label: "Reddedildi", color: "bg-rose-100 text-rose-700 border-rose-200" },
};

export default function Applications() {
  const qc = useQueryClient();
  const { data: apps = [] } = useQuery({ queryKey: ["admin-applications"], queryFn: () => get("/admin/applications") });

  const mut = useMutation({
    mutationFn: ({ id, status }) => patch(`/admin/applications/${id}`, { status }),
    onSuccess: (_d, v) => {
      qc.invalidateQueries({ queryKey: ["admin-applications"] });
      qc.invalidateQueries({ queryKey: ["admin-dashboard"] });
      toast.success(v.status === "approved" ? "Başvuru onaylandı" : "Başvuru reddedildi");
    },
  });

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Partner Başvuruları</h1>
      <p className="text-sm text-[#475569]">Yeni stüdyo başvurularını değerlendirin</p>

      <div className="mt-5 grid gap-4 lg:grid-cols-2">
        {apps.map((a) => {
          const st = APP_STATUS[a.status];
          return (
            <div key={a.id} data-testid={`application-${a.id}`} className="rounded border border-[#CBD5E1] bg-white p-5">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-lg font-semibold">{a.studio_name}</h3>
                  <p className="text-sm text-[#475569]">{CATEGORY_LABELS[a.category]} · {a.owner_name}</p>
                </div>
                <span className={`rounded border px-2 py-0.5 text-xs font-medium ${st.color}`}>{st.label}</span>
              </div>
              <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-sm text-[#475569]">
                <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {a.location}</span>
                <span className="flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" /> {a.email}</span>
                <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {new Date(a.applied_at).toLocaleDateString("tr-TR")}</span>
              </div>
              {a.status === "pending" && (
                <div className="mt-4 flex gap-2">
                  <button data-testid={`approve-application-${a.id}`} onClick={() => mut.mutate({ id: a.id, status: "approved" })} className="flex flex-1 items-center justify-center gap-1.5 rounded bg-[#0F172A] py-2 text-sm font-medium text-white transition-colors hover:bg-[#020617]"><Check className="h-4 w-4" /> Onayla</button>
                  <button data-testid={`reject-application-${a.id}`} onClick={() => mut.mutate({ id: a.id, status: "rejected" })} className="flex flex-1 items-center justify-center gap-1.5 rounded border border-[#CBD5E1] py-2 text-sm font-medium text-[#475569] transition-colors hover:border-rose-300 hover:text-rose-600"><X className="h-4 w-4" /> Reddet</button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
